import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@uidotdev/usehooks';
import { useSearchParams } from 'react-router-dom';
import { usePaymentContext } from '../../../../context/PaymentContext';
import ReactGA from 'react-ga4';
import { googleAnalyticsEvents } from '../../../../common/constants/googleAnalyticsEvents';
import styles from './PurchaseReportButton.module.scss';
import { useImpersonation } from '../../../../hooks/useImpersonation';
import { ReadOnlyNotice } from '../../../../components/impersonation/ReadOnlyNotice';

const PurchaseReportButton = () => {
    const { t } = useTranslation(['payment']);
    const getButtonBreakpoint = useMediaQuery('(max-width: 1107px)');
    const { selectedPlan, initiatePayment } = usePaymentContext();
    const [searchParams] = useSearchParams();
    // no checkout in a read-only impersonation
    const { isImpersonating } = useImpersonation();

    const vinCodeFromParams = searchParams.get('vincode');

    const handleGetReport = async () => {
        ReactGA.event(googleAnalyticsEvents.PAYMENT_INITIATED, {
            plan_name: selectedPlan?.productName,
        });

        await initiatePayment(vinCodeFromParams);
    };

    return (
        <>
            <ReadOnlyNotice />
            <button className={styles.getReportButton} onClick={handleGetReport} disabled={isImpersonating}>
                {getButtonBreakpoint ? t('getReport') : t('getReport')}
            </button>
        </>
    );
};

export default PurchaseReportButton;
